import React, { useState } from 'react';
import { Form } from 'semantic';
import { useAdvancedTariffFeatures } from 'components/tariffs/features';
import { useTranslation } from 'react-i18next';
import PriceInput from 'components/form-fields/Price';
import { max } from 'lodash-es';

type Props = {
  maxTotalCosts: number | undefined;
  onChange: (value: number | null) => void;
  currency: string;
};

export function TariffProfileCostLimits({
  maxTotalCosts: initialMaxTotalCosts,
  onChange,
  currency,
}: Props) {
  const advancedTariffsFeatures = useAdvancedTariffFeatures();
  const { t } = useTranslation();

  const [maxTotalCosts, setMaxTotalCosts] = useState(initialMaxTotalCosts ?? 0);

  const [enableMaxTotalCosts, setEnableMaxTotalCosts] = useState(
    (initialMaxTotalCosts ?? 0) > 0
  );

  if (!advancedTariffsFeatures.costLimits) {
    return <></>;
  }

  return (
    <>
      <Form.Field>
        <Form.Checkbox
          label={t(
            'advancedTariff.enableMaxTotalSessionCosts',
            'Configure a maximum total session cost'
          )}
          checked={enableMaxTotalCosts}
          onChange={(e, { checked }) => {
            if (checked) {
              onChange(maxTotalCosts);
            } else {
              onChange(null);
            }
            setEnableMaxTotalCosts(!!checked);
          }}
        />
      </Form.Field>
      {enableMaxTotalCosts && (
        <Form.Group widths={'equal'} style={{ marginBottom: 0 }}>
          <Form.Field disabled={!enableMaxTotalCosts}>
            <label>{t('advancedTariff.maxTotalCost', 'Max cost')}</label>
            <PriceInput
              value={maxTotalCosts}
              onChange={(value: number) => {
                setMaxTotalCosts(value);
                onChange(value > 0 ? value : null);
              }}
              currency={currency}
            />
          </Form.Field>
          <Form.Field />
        </Form.Group>
      )}
    </>
  );
}
